import {useState} from "react";
import {useLocation, useOutletContext, useParams} from "react-router-dom";
import {SistemaService} from "abastecemento/service";
import {sistema_view_adapter} from "abastecemento/model";
import {useNavigateWithReload} from "base/hooks";
import {EntityUpdatePanel} from "base/entity";
import {SistemaForm} from "../presentational/form";

const UpdateSistemaPanel = () => {
    const {section} = useParams();
    const location = useLocation();
    const baseLocationPath = location.pathname.split(section)[0];

    const [error, setError] = useState("");
    const navigate = useNavigateWithReload();

    let sistema;
    [sistema] = useOutletContext();

    const handleSubmit = sistema => {
        SistemaService.update(sistema_view_adapter({...sistema}))
            .then(() => {
                navigate(baseLocationPath, true);
            })
            .catch(error => {
                setError(error);
            });
    };

    const handleFormCancel = () => {
        navigate(baseLocationPath);
    };

    return (
        <EntityUpdatePanel
            form={
                <SistemaForm
                    sistema={sistema}
                    updatedSection={section}
                    onSubmit={handleSubmit}
                    onCancel={handleFormCancel}
                />
            }
            title="Modificar Sistema"
            error={error}
            onCancel={handleFormCancel}
        />
    );
};

export default UpdateSistemaPanel;
